import React from "react";
import { useParams } from "react-router-dom";
import { Logo } from "../../Component";
import Certificate from "./certificate";
import styles from "./unauth-preview.module.scss";
import { useUnauthPreviewCertificate } from "../../queries/previewCertificate";
import { Skeleton } from "@mui/material";

const UnauthPreviewCertificate = () => {
  const { id } = useParams();

  const { data, isLoading } = useUnauthPreviewCertificate(id || "");

  return (
    <main id={styles["custom-main-main"]}>
      <div id={styles["UnauthPreviewCertificate"]}>
        <header className={styles["PRC-header"]}>
          <p className={styles["collection-name"]}>
            {data?.collectionName || "....."}
          </p>
        </header>

        {data && <Certificate PreviewCertificate={data} />}
        {isLoading && !data && (
          <div className={styles["skeleton"]}>
            <Skeleton />
          </div>
        )}

        <footer>
          <span>Powered by</span> <Logo />
        </footer>
      </div>
    </main>
  );
};

export default UnauthPreviewCertificate;
